import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const SavePayment = async (payment,navigate) => {
  const accesstoken = getToken();

  if (accesstoken) {
    try {
          // console.log(Payload);
      const response = await fetch(`${dev_baseUrl}/Payment/save`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payment),
      });
        
      const data = await response.json();
      // console.log(data)
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else if(response.ok && !data.isError ){      
        return data;
      }       
    } catch (error) {
      console.error('Network error:', error);
      return { isError:true, message: 'An error occurred. Please try again later.' , error: error};
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};

export const getInvoices = async (navigate) => {
  const token = getToken();

  if (!token) {
    navigate('/login');
    throw new Error("No access token");
  }

  const res = await fetch(
    `${dev_baseUrl}/Invoice/get`,
    {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  const data = await res.json();
  // console.log(data)

  if (!res.ok || data.isError || !Array.isArray(data.result)) {
    throw new Error(data.message || "Error fetching invoices");
  }

  return data?.result || [];
};

export const getPayments = async (navigate) => {
  const token = getToken();

  if (!token) {
    navigate('/login');
    throw new Error("No access token");
  }

  const res = await fetch(
    `${dev_baseUrl}/Payment/get?recordsPerPage=50000000`,
    {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  const data = await res.json();
  // console.log(data)

  if (!res.ok || data.isError || !Array.isArray(data.result)) {
    throw new Error(data.message || "Error fetching payments");
  }

  return data?.result || [];
};

export const getInvoicePayments = async (invoiceID,navigate) => {
  const token = getToken();

  if (!token) {
    navigate('/login');
    throw new Error("No access token");
  }

  const res = await fetch(
    `${dev_baseUrl}/Payment/get?invoiceID=${invoiceID}&recordsPerPage=50000000`,
    {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  const data = await res.json();
  // console.log(data)

  if (!res.ok || data.isError || !Array.isArray(data.result)) {
    throw new Error(data.message || "Error fetching payments");
  }

  return data?.result || [];
};

export const GetPaymentLink = async (payload) => {  
  try {
    const queryParams = new URLSearchParams({
      token: payload.token,
      invoiceId: payload.invoiceId,
      paymentMethod: payload.paymentMethod,
      Notes: payload.notes,
      PaidBy: payload.PaidBy, 
    }).toString();
    const response = await fetch(`${dev_baseUrl}/CustomerPayment/VerifyAndGeneratePayment?${queryParams}`, {
      method: 'GET',
      headers: {        
        'Content-Type': 'application/json',
      },        
    });
      
    const data = await response.json();
         
    return data;   
  } catch (error) {
    console.error('Network error:', error);
    return { isError:true, message: 'An error occurred. Please try again later.' , error: error};
  }  
};